import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { TeamWithCount } from '../../../shared/domain/teams/types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/teams/syncTeams' }

type Params = never
type Body = never
type Query = { lastSyncTime?: Date }
type Output = {
    syncTime: Date
    teams: TeamWithCount[] // array of teams with member count
    deletions: number[] // ids of deleted teams
}

export type SyncTeamsEndpoint = Endpoint<Params, Body, Query, Output>

export const syncTeamsRequest = (request: Request, args: RequestArgs<SyncTeamsEndpoint>) =>
    request<SyncTeamsEndpoint>(route, args)
